<template>
  <div id="app">
    <!-- <router-view /> -->
    <scale-box :width="1920" :height="1080" bgc="transparent" :isFlat="true" :delay="100">
      <router-view></router-view>
    </scale-box>
  </div>
</template>

<script>
  import ScaleBox from "vue2-scale-box";
  export default {
    components: { ScaleBox },
  };
</script>